import script from "./StatsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsTable.vue?vue&type=script&setup=true&lang=js"

import "./StatsTable.vue?vue&type=style&index=0&id=942be22e&lang=scss&scoped=true"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-942be22e"]])

export default __exports__